<template>
    <div>
        <div class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="drawerShow=true">新增图片</el-button>
        </div>
        <el-alert v-if="data && data.media && data.media.length > 0" :show-icon="true" title="按住鼠标，可拖动排序" :closable="false"></el-alert>
        <div class="page-list-box">
            <el-row v-if="data" :gutter="10">
                <vuedraggable v-model="data.media" draggable=".img" @change="updateSort">
                    <el-col v-for="(item,index) in data.media" :key="index" class="img">
                        <el-image :src="item.path" fit="cover" :preview-src-list="data.media.map(v => v.path)">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                        <div class="tool">
                            <el-button icon="el-icon-delete" type="text" @click="del(item.id)" size="mini"></el-button>
                        </div>
                    </el-col>
                </vuedraggable>
            </el-row>
        </div>

        <el-drawer
            title="上传图片"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
        >
            <div class="drawer-content">
                <image-upload 
                    :url.sync="path" 
                    :urlFull.sync="path" 
                >
                </image-upload>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="addImg()" :loading="btnLoading"
                    >提交</el-button
                >
            </div>
        </el-drawer>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import vuedraggable from 'vuedraggable';
export default {
    props:{
        data:{
            type:Object,
            default:null
        },
        userType:{
            type:Number,
            default:2
        }
    },
    components:{ImageUpload,vuedraggable},
    data(){
        return{
            action:{
                2:{ // 艺人
                    del:'/performer/deleteMedia',
                    add:'/performer/addMedia',
                    sort:'/performer/mediaSort'
                },
                3:{ // 场地
                    del:'/site/deleteMedia',
                    add:'/site/addMedia',
                    sort:'/site/mediaSort'
                },
                5:{ // 厂牌
                    del:'/brand/deleteMedia',
                    add:'/brand/addMedia',
                    sort:'/brand/mediaSort'
                }
            },
            drawerShow:false,
            btnLoading:false,
            path:'',
            ids:[]
        }
    },
    methods:{
        //删除图片
        del(id){
            this.$confirm('删除后无法恢复，是否确认删除？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: this.action[this.userType].del,
                    method: "POST",
                    data: {
                        id:id
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.$emit('getDataList');
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        // this.listLoading = false;
                    });
            }).catch(() => {});
        },
        //关闭抽屉
        close(){
            this.path = '';
            this.drawerShow = false;
        },
        //新增图片；
        addImg(){
            if( this.path ){
                this.btnLoading = true;
                this.$request({
                    url: this.action[this.userType].add,
                    method: "POST",
                    data: {
                        path:this.path,
                        userId:this.data.idNameVO.id
                    },
                })
                    .then((res) => {
                        const { state, msg, result } = res.data;
                        if (state == 1 && result) {
                            this.$emit('getDataList');
                            this.close();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
            }else{
                return this.$message.error('请上传图片');
            }
        },
        //排序
        updateSort(){
            this.ids = this.data.media.map( v => v.id )
            // this.btnLoading = true;
            this.$request({
                url: this.action[this.userType].sort,
                method: "POST",
                data: {
                    ids:this.ids,
                    userId:this.data.idNameVO.id
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$message.success("设置成功");
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    // this.btnLoading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.img{
    border:1px $--color-border-gary solid;
    padding: 5px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 160px;
    position: relative;
    background: #ffffff;
    margin: 5px;
    .el-image{
        width: 100%;
        height: 100%;
    }
    .tool{
        display: none;
        position: absolute;
        right: 0;
        top: 0;
        background: #ffffff;
        height: 26px;
        width: 26px;
        text-align: center;
        border-radius: 4px;
        .el-button{
            height: 26px;
        }
    }
    &:hover{
        .tool{
            display: block;
        }
    }
}

</style>